export default class Contractor {
    constructor(values) {
        const { id, admin_id, name, business_type, tax_id, phone, contact_user, email_accounts_receivable, email_tax } = values;
        this.id = id;
        this.admin_id = admin_id;
        this.name = name;
        this.business_type = business_type;
        this.tax_id = tax_id;
        this.phone = phone;
        this.contact_user = contact_user;
        this.email_accounts_receivable = email_accounts_receivable;
        this.email_tax = email_tax;
    }
}



// WEBPACK FOOTER //
// ./src/models/contractor.jsx